import Cookies from 'js-cookie'

const TokenKey = 'Agent-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getLoginMode() {
  return Cookies.get('Login-Mode')
}

export function setLoginMode(loginMode) {
  return Cookies.set('Login-Mode', loginMode)
}

export function removeLoginMode() {
  return Cookies.remove('Login-Mode')
}

export function getSnsUrl(crtUrl, scope) {
  let recUrl = encodeURI(`${process.env.VUE_APP_BASE_API}/oa/auth?web_url=${encodeURI(crtUrl)}`)
  let snsUri = 'https://open.weixin.qq.com/connect/oauth2/authorize'
  let snsOther = `response_type=code&scope=${scope}&state=agent#wechat_redirect`
  return `${snsUri}?appid=${process.env.VUE_APPID}&redirect_uri=${recUrl}&${snsOther}`
}



// WEBPACK FOOTER //
// ./src/utils/auth.js